export default __webpack_public_path__ + "static/media/active-campaign.76dcf6a3.jpg";